import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/comunicaciones",
    label: "Comunicaciones",
    isActive: true,
  },
];

function Asistencia() {
  return (
    <Page
      title="Comunicaciones"
      description="Envío de notificaciones, mensajes y reportes masivos a clientes."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default Asistencia;
